
import React, { useEffect, useRef, useState } from "react";
import Card from "../Card"
import { HiOutlinePhotograph } from "react-icons/hi";
import { RiDeleteBin2Line } from "react-icons/ri";
import { FiEdit } from "react-icons/fi";
import GalleryLogo from "../../assest/gallery.png"
import {

    IconChevronsLeft,

} from "@tabler/icons-react";
import { useNavigate } from "react-router-dom";
//import { getGalleryAlbumData, getGalleryImagesData } from "../../controllers/galleryManagement.controller";
import { createGalleryAlbum, getGalleryAlbumData } from "../../controllers/galleryManagement.controller";
import toast from "react-hot-toast";
import Page from "../../Components/Page";


const Gallery = () => {


    const [previewValues, setPreviewValues] = useState([]);
    const [images, setImages] = useState([]);
    const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
    const [image, setImage] = useState(null);
    const navigate = useNavigate();


    const [isAddModalOpen, setIsAddModalOpen] = useState(true);
    const [modalData, setModalData] = useState({ index: null, value: "" });
    const [data, setData] = useState([]);
    const [selectedAlbumId, setSelectedAlbumId] = useState(null)


    const [uploadedImages, setUploadedImages] = useState([]);

    const add_album_name_ref = useRef()

    const handleImageUpload = (e) => {
        const files = Array.from(e.target.files);
        const newImages = files.map((file) => ({
            preview: URL.createObjectURL(file),
            name: file.name,
        }));
        setUploadedImages([...uploadedImages, ...newImages]);
    };

    const handleDeleteImage = (index) => {
        const updatedImages = [...uploadedImages];
        updatedImages.splice(index, 1);
        setUploadedImages(updatedImages);
    };



    const handlePreviewChange = (index, field, value) => {
        const updatedValues = [...previewValues];
        updatedValues[index][field] = value;
        setPreviewValues(updatedValues);
    };
    const handleSubmit = (e) => {
        e.preventDefault();

    };

    const handleAddImages = (e) => {
        e.preventDefault();
    }

    const handleImageChange = (event) => {
        const file = event.target.files[0];
        if (file) {
            setImage(URL.createObjectURL(file));
        }
    };


    const fetchTableData = async () => {
        const res = await getGalleryAlbumData()
        console.log('res => ', res)

        if (res.status === 200) {
            setData(res.data.data)
        }
    }

    useEffect(() => {
        fetchTableData()
    }, [])

    const createAlbum = async () => {
        try {
            const album_name = add_album_name_ref.current.value;
            toast.loading("plaese wait");
            const res = await createGalleryAlbum({ album_name })
            const message = res.data.message;
            toast.dismiss();
            if (res.status === 200) {
                toast.success(message);
                add_album_name_ref.current.value = ''
                fetchTableData()
            }
            else {
                toast.error(message);
            }

        } catch (error) {
            console.log(error);
            const message = error?.response?.data?.message || "something went wrong";
            toast.dismiss();
            toast.error(message);
        }
    }

    // const fetchimagesData = async () => {
    //     const res = await getGalleryImagesData();
    //     console.log('images res  => ', res)
    // if (res.status === 200) {
    //     setUploadedImages(res.data.data)
    // }
    // }

    // useEffect(() => {
    //     fetchimagesData()
    // }, [])

    useEffect(() => {
        if (selectedAlbumId) setUploadedImages(data?.find((d) => d?.album_id === selectedAlbumId)?.images || [])
        else setUploadedImages([])
    }, [selectedAlbumId])


    const handleRemoveImage = () => {
        setImage(null); // Reset the image state
    };

    return (
        <>
            <Page className="px-8 py-6">
        <div>
            <div className="max-w-6xl p-6 mx-auto bg-gray-100 rounded-lg shadow-md">
            <div className="flex items-center mb-6 space-x-2 text-3xl text-gray-500">
          <span>Gallery & News</span>
          <span>/</span>
          <span className="text-black">Gallery</span>
        </div>


                <div className="p-6 mb-10 bg-white rounded-lg shadow-md">
                    <h1
                        className="mb-4 text-xl font-bold text-gray-700"
                    >
                        Create Album
                    </h1>
                    <div className="mb-4">
                        <label className="block mb-2 text-gray-600">Add Album Name</label>
                    </div>
                    <div className="flex gap-4">
                        <input
                            ref={add_album_name_ref}
                            type="text"
                            className="w-[200px] px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:[#92288C]"
                        />
                        <button
                            onClick={() => { createAlbum() }}
                            className="bg-[#92288C] text-white py-2 px-4 rounded-lg hover:bg-[#92288C] focus:outline-none focus:ring-2 w-[150px] h-100"
                        >Create Album</button>
                    </div>
                </div>


                <div className="p-6 bg-white rounded-lg shadow-md">
                    <h2 className="mb-4 text-xl font-bold text-gray-700">Albums</h2>
                    <form>
                        <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4">

                            {data.map((d, i) => (
                                <div
                                    key={`image-card-${i}`}
                                    className="p-4 bg-white rounded-lg shadow-md"
                                >
                                    <h1 className="text-lg font-bold text-gray-800">
                                        {d.album_name}
                                    </h1>
                                    <img
                                        src={d.images.length > 0 ? d.images[0]?.image_url : GalleryLogo}
                                        alt="GalleryLogo"
                                        className="object-cover w-full h-40 mb-4 rounded-lg"
                                    />

                                    {/* <HiOutlinePhotograph  /> */}
                                    <div className="flex items-center justify-center w-8 h-8 rounded-md">
                                        <HiOutlinePhotograph className="text-[#92288C]" />
                                    </div>

                                    <h1 className="text-lg font-bold text-gray-800">
                                        Images Count {d.images.length}
                                  
                                    </h1>
                                    <button
                                        type="button"
                                        onClick={() => setIsDeleteModalOpen(true)}
                                        className="px-3 py-1 w-full text-center bg-[#A8AAAE14] text-[#A8AAAE] border border-[#A8AAAE] rounded-md hover:bg-gray-300 mt-5"
                                    >
                                        Delete Album
                                    </button>
                                    <button
                                        type="button"
                                        onClick={() => {
                                            setSelectedAlbumId(d.album_id)
                                            document.getElementById("modal-add-images").showModal();
                                        }}
                                        className="bg-[#92288C] text-white py-2 px-4 rounded-lg hover:bg-[#75006F] focus:outline-none focus:ring-2 w-full mt-5"
                                    >
                                        Add Images
                                    </button>

                                </div>
                            ))}

                        </div>
                    </form>


                    {/* {isDeleteModalOpen && (
                        <div className="relative z-10 w-full max-w-lg p-6 mx-auto bg-white rounded-lg shadow-lg">
                            <div className="text-center">
                                <h2 className="text-xl font-bold text-gray-900">
                                    Delete
                                </h2>
                                <p className="font-bold text-gray-500">
                                    Are you sure You want to delete this Album?
                                </p>
                                <p className="font-bold text-gray-500">
                                    {"Album Name"}
                                </p>
                            </div>


                            <div className="flex justify-center mt-4 space-x-4">
                                <button
                                    onClick={() =>
                                        document.getElementById("modal-delete").close()
                                    }
                                    className="px-6 py-3 text-gray-600 transition bg-gray-200 rounded-lg hover:bg-gray-200 active:scale-95 hover:shadow-lg"
                                >
                                    No
                                </button>
                                <button
                                    onClick={async () => {
                                        const deleteModal = document.getElementById("modal-delete");
                                        const deleteAlbumId =
                                            deleteModal.getAttribute("data-deleteId");
                                        console.log("deleteRowId => ", deleteAlbumId);
                                        await deleteAlbumId({ sliderId: deleteAlbumId });
                                        // if (REACT_APP_BACKEND_URL) {
                                        //   await mutate(REACT_APP_BACKEND_URL);
                                        // }
                                        deleteModal.close();
                                    }}
                                    className="rounded-lg transition active:scale-95 hover:shadow-lg px-6 py-3 bg-[#92288C] text-white"
                                >
                                    Yes
                                </button>
                            </div>
                        </div>

                    )} */}
                    {isDeleteModalOpen && (
                        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-25">
                            <div className="w-full max-w-lg p-6 mx-auto bg-white rounded-lg shadow-lg">
                                <div className="text-center">
                                    <h2 className="text-xl font-bold text-gray-900">Delete</h2>
                                    <p className="font-bold text-gray-500">
                                        Are you sure You want to delete this Album?
                                    </p>
                                    <p className="font-bold text-gray-500">{"Album Name"}</p>
                                </div>
                                <div className="flex justify-center mt-4 space-x-4">
                                    <button
                                        onClick={() => setIsDeleteModalOpen(false)} // Close modal on "No"
                                        className="px-6 py-3 text-gray-600 transition bg-gray-200 rounded-lg hover:bg-gray-200 active:scale-95 hover:shadow-lg"
                                    >
                                        No
                                    </button>
                                    <button
                                        onClick={() => {
                                            console.log("Album deleted!");
                                            setIsDeleteModalOpen(false); // Simulate deletion and close modal
                                        }}
                                        className="rounded-lg transition active:scale-95 hover:shadow-lg px-6 py-3 bg-[#92288C] text-white"
                                    >
                                        Yes
                                    </button>
                                </div>
                            </div>
                        </div>
                    )}





                    <dialog
                        id="modal-add-images"
                        className="inset-0 z-50 rounded-lg modal modal-bottom xl:modal-middle w-96"
                    >
                        <div className="fixed inset-0 z-50 flex items-center justify-center bg-gray-800 bg-opacity-75">
                            <div className="p-6 bg-white rounded-lg shadow-lg">
                                <h1 className="mb-4 text-lg font-bold">Add Images</h1>

                                <button
                                    onClick={() => {
                                        setSelectedAlbumId(null)
                                        document.getElementById("modal-add-images").close();
                                    }}
                                    className="text-[#92288C] flex items-center gap-2"
                                >
                                    <IconChevronsLeft />
                                    Back
                                </button>

                                <div className="mb-4">
                                    <div className="flex flex-col items-center justify-center mt-2 border-2 border-gray-300 border-dashed rounded-lg h-36">
                                        {image ? (
                                            <img src={image} alt="Uploaded Preview" className="object-contain w-auto h-28" />
                                        ) : (
                                            <div className="text-center text-gray-500">
                                                <p>Drag and drop image here</p>
                                                <p className="text-sm text-center text-gray-400">
                        Any size of image, will automatically adjust to the frame 
                        </p>
                                                <label className="text-[#92288C] cursor-pointer">
                                                    <input
                                                        type="file"
                                                        accept=".jpg, .png"
                                                        onChange={handleImageChange}
                                                        className="hidden"
                                                    />
                                                    Browse image
                                                </label>
                                                <button
                                                    onClick={handleRemoveImage}
                                                    className="px-4 py-2 bg-white text-[#EA5455] rounded-md border-2 border-[#EA5455] hover:bg-[#EA5455] hover:text-white"
                                                >
                                                    Remove Image
                                                </button>
                                            </div>
                                        )}
                                    </div>
                                </div>


                                <div className="p-6 bg-white rounded-lg shadow-md">
                                    <h2 className="mb-4 text-xl font-bold text-gray-700">Uploaded Images</h2>
                                    <table className="w-full border-collapse">
                                        <thead>
                                            <tr className="text-left text-gray-500 border-b">
                                                <th className="px-4 py-2">Preview</th>
                                                <th className="px-4 py-2">File Name</th>
                                                <th className="px-4 py-2">Actions</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {uploadedImages.map((image, index) => (
                                                <tr key={index} className="border-b">
                                                    <td className="px-4 py-2">
                                                        <img
                                                            src={image.image_url}
                                                            alt={image.image_id}
                                                            className="object-cover w-16 h-16 rounded-lg"
                                                        />
                                                    </td>
                                                    <td className="px-4 py-2">{image.image_path}</td>
                                                    <td className="px-4 py-2">
                                                        {/* <button
                    onClick={() => handleDeleteImage(index)}
                    className="flex items-center gap-1 text-grat"
                  >
                    <RiDeleteBin2Line />
                    Delete
                  </button> */}
                                                        <button
                                                            onClick={() => {
                                                                document.getElementById("modal-delete").showModal();
                                                            }}
                                                            className="flex items-center px-3 py-1 bg-[#A8AAAE14] text-[#A8AAAE] border border-[#A8AAAE] rounded-md hover:bg-gray-300"
                                                        >
                                                            Delete
                                                            <RiDeleteBin2Line className="ml-2" />
                                                        </button>
                                                    </td>
                                                </tr>
                                            ))}
                                            {uploadedImages.length === 0 && (
                                                <tr>
                                                    <td colSpan="3" className="py-4 text-center text-gray-500">
                                                        No images uploaded.
                                                    </td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </table>
                                </div>
                                {/* <div className="flex justify-end gap-4">
                                    <button
                                        onClick={() => setIsAddModalOpen(false)}
                                        className="px-4 py-2 bg-gray-300 rounded-md hover:bg-gray-400"
                                    >
                                        Close
                                    </button>
                                    <button className="px-4 py-2 bg-[#92288C] text-white rounded-md hover:bg-[#75006F]">
                                        Save
                                    </button>
                                </div> */}
                            </div>
                        </div>
                    </dialog>




                </div>



            </div>


        </div>
        </Page>
        </>
    )
}

export default Gallery
